import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100dvh;
  background: ${({ theme }) => theme.palette.background.default};
`;
